import styled from "styled-components";
import { fHeader } from "../../styles/global";
import { Link } from "react-router-dom";

export const TitleContainer = styled.div`
  position: relative;
  margin-bottom: 2rem;
`;

export const Title = styled.h1`
  ${fHeader}
  line-height: 1.17;
  padding-right: 12rem;
  @media (max-width: 768px) {
    min-height: ${1.17 * 4}em;
  }
`;

export const WorksList = styled.div`
  border-top: 1px solid black;
  padding-top: 1.3rem;
`;

export const Work = styled.div`
  ${"" /* width: ${props => (props.portrait ? "82%" : "auto")}; */}

  & + div {
    margin-top: 4.6rem;
  }
`;

export const ImageSizer = styled.div`
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const WorkInfo = styled.div`
  margin-top: 1.3rem;
  ${"" /* max-width: 25rem; */}

  em {
    font-style: italic;
  }
`;

export const PrevNext = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.6rem;

  @media (max-width: 768px) {
    position: absolute;
    top: 0.1rem;
    right: 0;
    margin-top: 0;
  }

  svg {
    display: block;
    fill: none;
    stroke: currentColor;
    stroke-width: 1;
    width: 3.2rem;
    height: 2.9rem;
  }

  a {
    margin-left: 1.6rem;
    @media (hover: hover) {
      &:hover {
        opacity: 0.5;
      }
    }
  }
`;

export const Next = styled(Link)`
  display: ${(props) => (props.$isHidden ? "none" : "block")};
`;

export const Prev = styled(Link)`
  display: ${(props) => (props.$isHidden ? "none" : "block")};
  svg {
    transform: rotate(-180deg);
  }
`;
